module.exports = __webpack_public_path__ + "static/media/slide-one.b94e024b.webp";